module.exports = __webpack_public_path__ + "img/past_cohorts_hero.e1349d8a.png";